"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdUnitComponent = void 0;
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const size_service_1 = require("./size.service");
const permission_service_1 = require("./permission.service");
const demand_partner_service_1 = require("./demand-partner.service");
const demand_partner_type_service_1 = require("./demand-partner-type.service");
const notification_service_1 = require("./notification.service");
const demand_partner_menu_service_1 = require("./demand-partner-menu.service");
const size_mapping_menu_service_1 = require("./size-mapping-menu.service");
const ad_unit_service_1 = require("./ad-unit.service");
const ad_unit_1 = require("./ad-unit");
const version_1 = require("./version");
const events_1 = require("./events");
const ng2_dragula_1 = require("ng2-dragula");
let AdUnitComponent = class AdUnitComponent {
    constructor(_cd, _size, _permission, _demandPartner, _demandPartnerType, _af, _talk, _demandPartnerMenu, _adService, _sizeMappingMenu, _dragulaService, document) {
        this._cd = _cd;
        this._size = _size;
        this._permission = _permission;
        this._demandPartner = _demandPartner;
        this._demandPartnerType = _demandPartnerType;
        this._af = _af;
        this._talk = _talk;
        this._demandPartnerMenu = _demandPartnerMenu;
        this._adService = _adService;
        this._sizeMappingMenu = _sizeMappingMenu;
        this._dragulaService = _dragulaService;
        this.document = document;
        this.ad = 0;
        this.bidCPMAdjustments = new Array();
        this.engageHolisticResequencer = false;
        this.demandPartnerAdd = new core_1.EventEmitter();
        this.demandPartnerRemove = new core_1.EventEmitter();
        this.serverSelect = true;
        this.typePermissions = 0;
        this.tempChangedBrtAdapterEnabled = false;
        this.myOptions = this._size.get();
        this.permission = this._permission.get();
        this.typePermissions = this._demandPartnerType.permissionedTypes().length;
    }
    typeOf(v) {
        return typeof v;
    }
    sizeMappingSwitch() {
        this.adUnit.sizeMapping.activated = !this.adUnit.sizeMapping.activated;
        if (!this.adUnit.sizeMapping.activated) {
            this.adUnit.sizeMapping.devices = [];
        }
    }
    ngOnInit() {
        this.initDragulaListeners();
    }
    initDragulaListeners() {
        this._dragulaService.setOptions(this.dragulaClientID(), {});
        this._dragulaService.drag.subscribe(result => {
            this.previousDemandPartners = JSON.parse(JSON.stringify(this.adUnit.demandPartners));
        });
        this._dragulaService.out.subscribe(result => {
            this.currentDemandPartners = this.adUnit.demandPartners;
            this.events.batchAdd(this.events.demandPartnerHelper.moved(this.previousDemandPartners.client, this.currentDemandPartners.client));
        });
    }
    dragulaClientID() {
        return `ad_${this.ad}client`;
    }
    dragulaServerID() {
        return `ad_${this.ad}server`;
    }
    updateDemandPartnersPositions(demandPartners) {
        const partnersPositionsChanges = demandPartners.reduce((changed, partner, currentIdx) => {
            if (partner.position !== currentIdx) {
                changed.push({ id: partner.adUnitPartnerId, position: currentIdx });
            }
            return changed;
        }, []);
        if (partnersPositionsChanges.length)
            this.submitDemandPartnersChanges(partnersPositionsChanges);
    }
    submitDemandPartnersChanges(partnerChanges) {
        return __awaiter(this, void 0, void 0, function* () {
            const errors = [];
            for (let partner of partnerChanges) {
                const { id } = partner, updateValues = __rest(partner, ["id"]);
                try {
                    yield this._demandPartner.updatePartner(id, updateValues);
                }
                catch (error) {
                    errors.push({
                        partnerName: (this.adUnit.demandPartners.client[partner.position] ? this.adUnit.demandPartners.client[partner.position].displayName : id),
                        error
                    });
                }
            }
            if (errors.length)
                this.displayDemandPartnersErrors(errors);
        });
    }
    displayDemandPartnersErrors(errors) {
        const errorsMessages = errors.reduce((msgs, error) => (msgs += `<li>Unable to update partner <strong>${error.partnerName}</strong></li>`, msgs), "");
        this._talk.broadcast(`
      <p>Oops! We had a problem updating Demand Partners: </p>
      <ul>${errorsMessages}</ul>
      <p>Please try again. If problem persists, please submit a support request.</p>
    `);
    }
    demandPartnersExpand(state) {
        for (let dP in this.adUnit.demandPartners.client) {
            this.adUnit.demandPartners.client[dP].expanded = state;
        }
    }
    removeAdUnit() {
        for (let aU = 0; aU < this.adUnits.length; aU++) {
            if ((this.adUnits[aU].displayName == this.adUnit.displayName) && (this.adUnits[aU].div == this.adUnit.div) && (this.adUnits[aU].code == this.adUnit.code)) {
                Promise.resolve(this.adUnits[aU].id)
                    .then((adId) => {
                    //if no adId or bidder copy then this is an new ad, so just remove it from local ads
                    if (!adId || this.isCopy)
                        return null;
                    return this._adService.deleteAdUnit(adId);
                })
                    .then((response) => {
                    //Remove from local
                    this.adUnits.splice(aU, 1);
                })
                    .catch((err) => {
                    //console.error('Eror deleting Ad Unit', err);
                    this._talk.broadcast(`<h1>Oops! We had a problem deleting ${this.adUnit.displayName || 'this'} Ad Unit.</h1>`);
                });
                return true;
            }
        }
        return true;
    }
    removeAdUnitX() {
        let confirmPromptText = this.adUnit.displayName ? 'Are you sure you want to delete ' + this.adUnit.displayName + '?' : 'Are you sure you want to delete this Ad Unit';
        let removeRequest = this._talk.confirm(confirmPromptText);
        removeRequest.then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        this.events.add({
                            subFeature: events_1.EventSubFeature.adUnit,
                            subject: this.adUnit.displayName,
                            subjectID: this.adUnit.id,
                            action: events_1.EventAction.deleted,
                        });
                        return this.removeAdUnit();
                    }
                });
        });
    }
    moveAdUnit(direction, ad) {
        let oldAdUnits = Object.assign([], this.adUnits);
        let index = direction + ad;
        let movingTruck = this.adUnits.splice(ad, 1)[0];
        this.adUnits.splice(index, 0, movingTruck);
        let newAdUnits = this.adUnits;
        this.events.batchAdd(this.events.adUnitHelper.moved(oldAdUnits, newAdUnits));
    }
    modalName() {
        return 'size-mapping-modal-' + this.ad;
    }
    sizeMappingHelp() {
        this._talk.broadcast("The size mapping feature allows you to request different ad sizes depending on the window width (screen size). Your DFP ad unit must be configured to display all possible request sizes selected in the size mapping feature.");
    }
    hardFloorHelp() {
        this._talk.broadcast("Your Ad Unit specific Hard Floor price isactivated across a single Ad Unit when input and saved. The Ad Unit Hard Floor represents the minimum price to win a bid for a specific Ad Unit. If bids are below the Hard Floor for this Ad Unit, then no bid wins the header bidding auction for this Ad Unit. When bids are at or above the Hard Floor, normal auction dynamics will apply. This Hard Floor only applies to this Ad Unit");
    }
    scrollRowLeft(event) {
        /*let elm=$("#demandPartnerArray"+type+pos);
         if(elm[0].offsetWidth < elm[0].scrollWidth&&elm[0].scrollLeft>0) {
         elm.animate({
         scrollLeft: elm.scrollLeft() - 5
         }, 10);
         }
         else{
         this.document.body.scrollTop=this.document.body.scrollTop-100;
         }*/
    }
    scrollRowRight(event, pos, type) {
        let elm = $("#demandPartnerArray" + type + pos);
        if (elm[0].scrollWidth > elm[0].offsetWidth && (elm[0].scrollLeft < (elm[0].scrollWidth - elm[0].offsetWidth))) {
            elm.animate({
                scrollLeft: elm.scrollLeft() + 5
            }, 10);
        }
        else {
            this.document.body.scrollTop = this.document.body.scrollTop + 100;
        }
    }
    toggleAdUnit() {
        this.adUnit.enabled = !this.adUnit.enabled;
        this.events.add({
            subFeature: events_1.EventSubFeature.adUnit,
            subject: this.adUnit.displayName,
            subjectID: this.adUnit.id,
            action: this.adUnit.enabled ? events_1.EventAction.enabled : events_1.EventAction.disabled
        });
    }
};
exports.AdUnitComponent = AdUnitComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], AdUnitComponent.prototype, "ad", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", ad_unit_1.AdUnit)
], AdUnitComponent.prototype, "adUnit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], AdUnitComponent.prototype, "adUnits", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], AdUnitComponent.prototype, "bidCPMAdjustments", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], AdUnitComponent.prototype, "engageHolisticResequencer", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", version_1.Version)
], AdUnitComponent.prototype, "version", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdUnitComponent.prototype, "integration", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], AdUnitComponent.prototype, "adUnitHardFloor", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], AdUnitComponent.prototype, "isCopy", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", events_1.ControlCenterEvents)
], AdUnitComponent.prototype, "events", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], AdUnitComponent.prototype, "demandPartnerAdd", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], AdUnitComponent.prototype, "demandPartnerRemove", void 0);
exports.AdUnitComponent = AdUnitComponent = __decorate([
    (0, core_1.Component)({
        selector: 'myAdUnit',
        templateUrl: 'app/ad-unit.component.html',
        viewProviders: [ng2_dragula_1.DragulaService]
    }),
    __param(11, (0, core_1.Inject)(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [core_1.ChangeDetectorRef,
        size_service_1.SizeService,
        permission_service_1.PermissionService,
        demand_partner_service_1.DemandPartnerService,
        demand_partner_type_service_1.DemandPartnerTypeService,
        core_1.ApplicationRef,
        notification_service_1.NotificationService,
        demand_partner_menu_service_1.DemandPartnerMenuService,
        ad_unit_service_1.AdUnitService,
        size_mapping_menu_service_1.SizeMappingMenuService,
        ng2_dragula_1.DragulaService,
        Document])
], AdUnitComponent);
//# sourceMappingURL=ad-unit.component.js.map